import { Result } from 'journeys/portal/Forms/Sections.constants';
import { ReCalibrationNeededS81 } from './S81.formulas';

export const AsFoundTestTableSectionDataS81 = (selectedTag, formData) => ({
    rows: [
        {
            key: 1,
            fields: [{
                key: 'AsFoundTestLabel',
                label: 'As Found Test',
                isLabel: true,
                xs: 12,
                fontWeight: 700,
                padding: '5px 0 0 8px'
            }]
        },
        {
            key: 2,
            fields: [{
                key: 'remark',
                label: `Remark: If a PASS then required to take a picture of the One Pager document and the Beamex latest Calibration Cert document.
                If a FAIL, then re-Calibration is needed and then capture As Left Test Results. Submit is not allowed unless doc pictures are present.`,
                isLabel: true,
                xs: 12,
                fontWeight: '600',
                labelWidth: '100%',
                padding: '5px 1px 5px 8px',
                fontSize: '8.5pt',
                color: '#ea7c34',
            }]
        },
        {
            key: 3,
            fields: [{
                key: 'noData',
                isLabel: true,
                xs: 4
            },
            {
                key: 'F218AftIsRecalibrationNeededLabel',
                value: 'Re-Calibration Needed?',
                width: '100%',
                readOnly: true,
                labelWidth: '0',
                height: '1.1rem',
                xs: 2,
                borderBottom: '0',
                borderRight: '0',
                borderTop: '0',
                borderLeft: '0',
                isLabelBold: true,
                textAlign: 'end',
                marginTop: '2px'
            },
            {
                key: 'F218AftIsRecalibrationNeeded',
                value: ReCalibrationNeededS81(formData),
                readOnly: true,
                isCalculatedNew: true,
                xs: 2,
                width: '100%',
                labelWidth: '0',
                textAlign: 'center',
                height: '1.25rem',
                inputMarginRight: '0',
                borderBottom: '0',
                marginBottom: '4px'
            },
            {
                key: 'F102AftResultLabel',
                value: Result.AS_FOUND_RESULT_LABEL,
                width: '100%',
                readOnly: true,
                labelWidth: '0',
                height: '1.25rem',
                xs: 2,
                borderBottom: '0',
                borderRight: '0',
                borderTop: '0',
                borderLeft: '0',
                isLabelBold: true,
                textAlign: 'end',
                marginTop: '2px'
            },
            {
                key: 'F102AftResult',
                value: formData.F102AftResult,
                isRequired: true,
                isDropdown: true,
                placeholder: 'Select As-Found Result',
                options: [
                    { name: 'Select As-Found Result', value: '' },
                    { name: Result.RESULT_PASS, value: Result.RESULT_PASS },
                    { name: Result.RESULT_FAIL, value: Result.RESULT_FAIL }
                ],
                xs: 2,
                width: '98%',
                height: '1.5rem',
                labelWidth: '0',
                borderRight: '0',
                borderBottom: '0',
                marginBottom: '4px',
                textAlign: 'center'
            }]
        }
    ]
});
